import React from "react";
import { Icon } from "./Icon";

export type PillKind =
  | "active" | "suspended" | "inactive" | "muted" | "accent" | "filter";

type PillProps = {
  kind?: PillKind;
  dot?: boolean;
  onRemove?: () => void;
  children: React.ReactNode;
};

export function Pill({ kind = "inactive", dot = true, onRemove, children }: PillProps) {
  return (
    <span className={`pill ${kind}`}>
      {dot && kind !== "filter" && <span className="dot" />}
      {children}
      {onRemove && (
        <button className="x" onClick={onRemove} aria-label="Remove filter">
          <Icon name="x" />
        </button>
      )}
    </span>
  );
}
